<template>
    <c-dialog ref="dialog" title="确认退货" width="600" mask-close>
        <div class="m-return-confirm-body">
            <div class="m-return-address">
                <label>退货地址：</label>
                <p v-if="isBatch">已选择 {{returnOrders.length}} 张退货单，退货地址：{{returnAddress || '-'}}</p>
                <p v-else>{{returnOrder.returnee_name || '-'}} {{returnOrder.returnee_phone || '-'}}<br>{{returnOrder.returnee_address || '-'}}</p>
            </div>
            <div class="m-return-item">
                <label>寄件方式</label>
                <c-radio-group v-model="expressType" :options="expressTypeOptions" :clear="false"></c-radio-group>
            </div>
            <div class="m-return-item">
                <label><span>*</span>{{expressType === 'electronic' ? '电子面单号' : '退货快递单号'}}</label>
                <c-input v-model="expressNo" :placeholder="expressType === 'electronic' ? '请输入电子面单号' : '请输入快递单号'" maxlength="50">
                    <template #appendIcon><i class="tf-scan"></i></template>
                </c-input>
            </div>
        </div>

        <template #button>
            <c-button size="dialog" color="main" :loading="submitting" @click="submitHandle">确认退货</c-button>
            <c-button size="dialog" :disabled="submitting" @click="$refs.dialog.close()">取消</c-button>
        </template>
    </c-dialog>
</template>

<script>
export default {
    name: 'purchaseReturnConfirm',

    data() {
        return {
            returnOrders: [],
            expressType: 'manual',
            expressTypeOptions: [
                {name: '手动录入', value: 'manual'}
                // ,{name: '电子面单', value: 'electronic'}
            ],
            expressNo: '',
            submitting: false
        }
    },

    computed: {
        isBatch() {
            return this.returnOrders.length > 1;
        },

        returnOrder() {
            return this.returnOrders[0] || {};
        },

        returnAddress() {
            return this.returnOrder.returnee_address || '';
        }
    },

    methods: {
        open(data = {}) {
            this.returnOrders = (data.returnOrders || []).filter(item => item && item.id);
            this.expressType = 'manual';
            this.expressNo = '';
            this.submitting = false;
            this.$refs.dialog.open();
        },

        submitHandle() {
            if (!this.returnOrders.length) {
                this.$message({message: '未获取到采购退货单', type: 'warn'});
                return;
            }
            if (!this.expressNo.trim()) {
                this.$message({message: '请输入退货快递单号', type: 'warn'});
                return;
            }
            this.submitting = true;
            this.confirmNext(0);
        },

        confirmNext(index) {
            if (index >= this.returnOrders.length) {
                this.submitting = false;
                this.$message({message: '确认退货成功', type: 'success'});
                this.$refs.dialog.close();
                this.$emit('resolve');
                return;
            }
            this.request({
                url: '/purchase/return/confirm',
                data: {
                    purchase_return_order_id: this.returnOrders[index].id,
                    express_no: this.expressNo.trim()
                },
                loading: true,
                success: () => {
                    this.confirmNext(index + 1);
                },
                fail: () => {
                    this.submitting = false;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.m-return-confirm-body {
    padding 12px 24px
}

.m-return-address {
    margin-bottom 20px
    padding 12px
    background #fff3f3
    color #333

    label {
        display block
        margin-bottom 6px
        color #f56c6c
    }

    p {
        margin 0
        line-height 22px
    }
}

.m-return-item {
    margin-bottom 18px

    > label {
        display block
        margin-bottom 8px
        color #333

        span {
            margin-right 4px
            color #f56c6c
        }
    }
}
</style>
